import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/main-app/src/app/(public)/roast-my-resume/modules/RoastResume.tsx");
